import { scrollTopForce } from './Util.js';
import { checkSubscribePopupTrigger, closeSubscribePopup } from './PopupBottom.js';

barba.init({
    transitions: [{
        name: 'next-case',
        from: {
            namespace: 'case',
        },
        to: {
            namespace: 'case',
        },
        leave() {
            const done = this.async();

            // App.W.trigger('form:close');
            $('.js-preloader-case').addClass('preloader-case--next');
            setTimeout(() => {

                // Удаляем класс страницы
                App.H.removeClass('page-main page-category page-design-accompaniment page-case page-about page-404 page-projects');
                closeSubscribePopup();

                $('html, body').scrollTop(0);
                scrollTopForce();

                done();
            }, 4100);
        },
        enter(data) {
            const done = this.async();

            // Добавляем странице класс
            App.H.addClass('page-' + data.next.namespace);
            App.formIsOpen = false;

            App.H.find('[data-appear-immediately]').removeClass('appear').removeAttr('data-appear-immediately');

            // Время, через которое поднимется прелоадер

            // Скроллим новую страницу вверх
            $('html, body').scrollTop(0);
            scrollTopForce();

            done();

            // Обновляем счётчик времени для антиспама в форме
            App.secondsOnPage = 0;

            // Передаём события в аналитику
            App.D.trigger('ga:dimension');
            App.D.trigger('ga:pageview');
        }
    }, {
        name: 'default',
        leave({trigger}) {
            // Анимация выгрузки
            const done = this.async();


            App.W.trigger('preloader:unload');


            // Время, за которое опустится прелоадер
            setTimeout(() => {
                // Если это переход из меню, закрываем его
                if ($(trigger).closest('.js-menu').length) {
                    App.W.trigger('menu:close');
                }

                App.W.trigger('form:close');

                // Удаляем класс страницы
                App.H.removeClass('page-main page-category page-design-accompaniment page-case page-about page-404 page-projects');
                closeSubscribePopup();

                // Скроллим старую страницу вверх
                $('html, body').scrollTop(0);
                scrollTopForce();

                done();
            }, 300);
        },
        enter(data) {
            // Анимация загрузки
            const done = this.async();
            // Стартуем прогресс-бар (таймаут – хак для сброса кэша хрома)
            setTimeout(() => {
                App.W.trigger('preloader:loading');
            }, 1);

            // Добавляем странице класс
            App.H.addClass('page-' + data.next.namespace);

            let $newPageHead = $('<head />').html(
                $.parseHTML(
                    data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0]
                    , document
                    , true
                )
            );
            let headTags = [
                "meta[name='keywords']"
                , "meta[name='description']"
                , "meta[property^='og']"
                , "meta[name^='twitter']"
                , "meta[itemprop]"
                , "link[itemprop]"
                , "link[rel='prev']"
                , "link[rel='next']"
                , "link[rel='canonical']"
            ].join(',');
            $('head').find(headTags).remove(); // Remove current head tags
            $newPageHead.find(headTags).appendTo('head'); // Append new tags to the head

            // Время, через которое поднимется прелоадер
            setTimeout(() => {
                done();

                // Скроллим новую страницу вверх
                $('html, body').scrollTop(0);
                scrollTopForce();

                App.W.trigger('preloader:loaded');
            }, 500);

            // Обновляем счётчик времени для антиспама в форме
            App.secondsOnPage = 0;

            // Передаём события в аналитику
            App.D.trigger('ga:dimension');
            App.D.trigger('ga:pageview');
        }
    },{
        name: 'next-project',
        from: {
            namespace: 'projects',
        },
        to: {
            namespace: 'projects',
        },
        leave() {
            const done = this.async();

            $('.js-projects-list').find('[data-in-view-once]').attr('data-in-view-once', '');

            // Время, через которое поднимутся все шорки кейсов
            setTimeout(() => {
                scrollTopForce();
                done();
            }, 400);
        },
        enter(data) {
            const done = this.async();

            // Добавляем странице класс
            App.H.addClass('page-' + data.next.namespace);

            scrollTopForce();
            done();

            // Обновляем счётчик времени для антиспама в форме
            App.secondsOnPage = 0;

            // Передаём события в аналитику
            App.D.trigger('ga:dimension');
            App.D.trigger('ga:pageview');
        }
    }]
});



// Генерируем события

// Сразу при выгрузке страницы
barba.hooks.leave(() => {
    App.W.trigger('barba:leave');
    //console.log('barba:leave — выгрузка');
});

// Когда анимация выхода закончится
barba.hooks.afterLeave(() => {
    App.W.trigger('barba:afterLeave');
    //console.log('barba:afterLeave — после анимации выгрузки');
});


barba.hooks.beforeEnter(() => {
    App.W.trigger('barba:beforeEnter');
    //console.log('beforeEnter — перед загрузкой');
});

// Сразу при загрузке страницы
barba.hooks.enter(() => {
    App.W.trigger('barba:enter');
    //console.log('barba:enter — загрузка');
});

// Когда анимация входа закончится (при первом заходе на сайт сразу же)
barba.hooks.afterEnter((data) => {
    App.W.trigger('barba:afterEnter', data);
    //console.log('barba:afterEnter — после анимации загрузки');

    checkSubscribePopupTrigger();

    let readyState,
        counter = 0;
    let planeInterval = setInterval(function() {
        readyState = document.readyState;
        counter++;

        if (readyState == 'complete' || counter == 10) {
            clearInterval(planeInterval);
            if ($('.js-airplane').length) {
                setTimeout(function() {
                    document.getElementById('plane').removeAttribute('style');
                    document.getElementById('plane').removeAttribute('class');
                    document.getElementById('track').setAttribute('class', 'anim-track');
                    document.getElementById('track-past').setAttribute('class', 'anim-track-past');

                    let path = anime.path(document.getElementById('track'));
                    anime({
                        targets: document.getElementById('plane'),
                        translateX: path('x'),
                        translateY: path('y'),
                        rotate: path('angle'),
                        easing: 'linear',
                        duration: 9000,
                        loop: false
                    });
                }, 500);
                setTimeout(function() {
                    let path = anime.path(document.getElementById('track-circle'));
                    anime({
                        targets: document.getElementById('plane'),
                        translateX: path('x'),
                        translateY: path('y'),
                        rotate: path('angle'),
                        easing: 'linear',
                        duration: 2000,
                        loop: true
                    });
                    document.getElementById('track-sign').setAttribute('class', 'airplane-link _active');
                    document.getElementById('track-circle-white').setAttribute('class', 'anim-track-circle');
                }, 9500);
            }
        }
    }, 200);
});

// При первой загрузке страницы
setTimeout(() => {
    App.W.trigger('preloader:loaded');

    if (App.H.find('[data-barba-namespace="case"]').length) {
        App.H.find('.js-header-right').hide();
    } else {
        App.H.find('.js-header-right-case').hide();
    }
}, 1000);



// WEBPACK FOOTER //
// ./_src/js/modules/AjaxNavigation.js